/* eslint-disable react-refresh/only-export-components */
/**
 * Providers Index
 * Combines all providers into a single component
 * Using Zustand for state management
 * Ant Design App component provides hooks API (v5+ recommended)
 */

import React from "react";

import { App } from "antd";
import { BrowserRouter } from "react-router-dom";

import { QueryProvider } from "./QueryProvider";
import { ThemeProvider } from "./ThemeProvider";

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <QueryProvider>
      <BrowserRouter>
        <ThemeProvider defaultTheme="dark">
          <App>{children}</App>
        </ThemeProvider>
      </BrowserRouter>
    </QueryProvider>
  );
};

// Export providers (for cases where they need to be used individually)
export { ThemeProvider } from "./ThemeProvider";
export { QueryProvider, queryClient } from "./QueryProvider";

// Export hooks from Zustand stores (preferred way to access state)
export { useTheme } from "@/store/themeStore";
